<template>
  <div class="par-kartica">

    <div class="ime">{{document.partnerName}}</div>
    <div class="redak" v-if="document.partnerVATID">{{lang.VATID}}{{document.partnerVATID}}</div>
    <div class="redak">
      {{document.partnerStreet}} {{document.partnerBuildingNameNumber}}
    </div>
    <div class="redak">
      {{document.partnerPostcode}} {{document.partnerCity}}<span v-if="document.partnerState">, {{document.partnerState}}</span>
    </div>
    <div class="redak mt-2" v-if="document.partneremail || document.partnerPhones">
      {{document.partneremail}}<span v-if="document.partnerPhones"> · {{document.partnerPhones}}</span>
    </div>
    <div class="redak" v-if="document.partnerVATID ==='00000000000'">
      {{document.partnerSecretaryFirst}} {{document.partnerSecretaryLast}} {{document.partnerSecretaryPhone}}
    </div>
    <div class="redak" v-if="document.NazivPoslovneJedinice">
      Poslovnica: {{document.NazivPoslovneJedinice}}
    </div>

    <div class="mt-2">
      <v-btn text small color="primary" class="pl-0" @click="showDialog">Detaljno</v-btn>
    </div>

    <v-dialog v-model="dialog"  width="500">
      <v-card>
        <div v-if="partnerNijeNadjen" class="pa-4">
          <div class="text-subtitle-1 font-weight-medium">{{ document.partnerName }}</div>
          <div class="redak mt-2">
            Partner s OIB-om {{ oibPartnera }} nije pronađen u šifrarniku, pa se detalji ne mogu prikazati.
            Podaci na dokumentu su ostali kakvi su bili u trenutku izdavanja.
          </div>
        </div>
        <PartnerViewSmall v-if="!partnerNijeNadjen" :key="kljucPartnera" />
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import langEn from './documentDescEn'
import langHr from './documentDescHR'
import commEn from '@/language/commonEN'
import commHr from '@/language/commonHR'
import PartnerViewSmall from '../Partner/PartnerViewSmall.vue'
import PartnerService from '@/services/PartnerService'

export default {
  data() {
    return {
      document: {},
      locCreatedAt: '',
      locUpdatedAt: '',
      lang: {},
      langC: {},
      dialog: false,
      kljucPartnera: 0,
      partnerNijeNadjen: false
    }
  },
  mounted() {
    if (this.$store.state.language === 'EN') {
      this.lang = langEn
      this.langC = commEn
    }
    if (this.$store.state.language === 'HR') {
      this.lang = langHr
      this.langC = commHr
    }
    console.log('View card2 this.$store.state.documentActivHead', this.$store.state.documentActivHead.partnerVATID)
    if (this.$store.state.documentActivHead) {
      this.document = this.$store.state.documentActivHead
    }
  },
  computed: {
    oibPartnera () {
      return this.document.partnerVATID ? String(this.document.partnerVATID).trim() : ''
    }
  },
  methods: {
    async showDialog () {
      if (this.dialog) {
        this.dialog = false
        return
      }
      // PartnerViewSmall cita partnera iz store-a po OIB-u i to radi u mounted.
      // Bez postavljenog OIB-a dijalog se otvarao prazan, a bez promjene kljuca
      // ne bi se osvjezio kad se otvori za drugi racun.
      // Na 227 dokumenata OIB je spremljen s razmakom na pocetku, pa poziv
      // sifrarnika vraca 404 - zato se odsijeku razmaci.
      const oib = this.oibPartnera
      this.partnerNijeNadjen = false
      if (!oib) {
        this.partnerNijeNadjen = true
      } else {
        try {
          const nadjen = await PartnerService.show(oib)
          this.partnerNijeNadjen = !(nadjen && nadjen.data && nadjen.data.partner)
        } catch (err) {
          this.partnerNijeNadjen = true
        }
      }
      await this.$store.dispatch('setPartnerVATID', oib)
      this.kljucPartnera += 1
      this.dialog = true
    },
  },
  components: {
    PartnerViewSmall
  }
}
</script>

<style>
.par-kartica .ime { font-size: 17px; font-weight: 500; }
.par-kartica .redak { color: rgba(0,0,0,.6); font-size: 13px; margin-top: 2px; }


</style>